import React from "react";
import { Tooltip } from "antd";
import { useSearchParams } from "react-router-dom";
import { gotoPdp } from "../../../utils/activityHelper";
import { USER_TYPE } from "../../../utils/constant";
import defaultProductPic from "../../../images/default-brand.jpg";
import addToCartIcon from "../../../images/addToCart.svg";
import MAddOnPurchasePriceWidget from "./MAddOnPurchasePriceWidget";
import { useAddOnPurchaseCart } from "../../activity/add-on-purchase/useAddOnPurchaseCart";
import type { AddOnPurchaseCardProps } from "../../activity/add-on-purchase/types";

const MAddOnPurchaseProductCard: React.FC<AddOnPurchaseCardProps> = (props) => {
  const { product, loginState } = props;
  const [searchParams] = useSearchParams();
  const { processing, addToCart } = useAddOnPurchaseCart(props, "mobile");
  const isEmployee = loginState.userType === USER_TYPE.EMPLOYEE;
  const showDetails = () => gotoPdp(product, loginState, "Activity_Detail", true, searchParams.get("filter"));
  return (
    <div className="productCardWrapper addOnPurchaseCard">
      <div className="productCard">
        <div className="imgWrapper">
          <img alt={product.productName} src={product.productPic || defaultProductPic} onClick={showDetails} />
        </div>
        <div className="right">
          <div className="line line1">
            <span>{product.sku}</span>
            {product.productSize && <><span className="vdivider" />
              <span dangerouslySetInnerHTML={{ __html: product.productSize }} /></>}
          </div>
          <Tooltip title={<div dangerouslySetInnerHTML={{ __html: product.productName || "" }} />}>
            <div className={`line line2 ${product.pdpViewable && !isEmployee ? "linkable" : ""}`}
              style={{ color: isEmployee ? undefined : "#005daa" }} onClick={showDetails}
              dangerouslySetInnerHTML={{ __html: product.productName || "" }} />
          </Tooltip>
          {product.description && <Tooltip title={product.description}>
            <div className="line line3" dangerouslySetInnerHTML={{ __html: product.description }} />
          </Tooltip>}
          <div className="line line5">
            <MAddOnPurchasePriceWidget product={product} loginState={loginState} />
            <button type="button" className="addOnPurchaseMobileCart" disabled={processing}
              aria-label="加购" onClick={(event) => { event.stopPropagation(); addToCart(1); }}>
              {loginState.status !== "login" || product.available ? (
                <img src={addToCartIcon} alt="addToCart" />
              ) : <span className="addOnPurchaseSoldOut">已售罄</span>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MAddOnPurchaseProductCard;
